import React from 'react'
import BuyUpper from './buyUpper'
import BuyDisclaimer from './buyDisclaimer'
import BuyTrading from './buyTrading'

export default function Buycoin() {
  return (
    <>
      <BuyUpper />
      <BuyDisclaimer />
      <BuyTrading />
    </>
  )
}
